import angular from "angular"
import "front-end-web-commons"

export default angular.module("truckAllocationModule", [
    "nlgTruckAllocationModule"
])